import { Apprenti, StatutCv } from '../../../domain/models';

export const CV_STATUT_LABELS: Record<StatutCv, string> = {
  'not-created': 'Non créé',
  'in-progress': 'En cours',
  valid: 'Validé',
  'correction-pending': 'Correction en attente',
  'correction-sent': 'Correction envoyée',
};

export const CV_STATUT_BADGES: Record<StatutCv, string> = {
  'not-created':
    'bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400',
  'in-progress':
    'bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400',
  valid:
    'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400',
  'correction-pending':
    'bg-orange-100 text-orange-700 dark:bg-orange-500/15 dark:text-orange-400',
  'correction-sent':
    'bg-orange-100 text-orange-700 dark:bg-orange-500/15 dark:text-orange-400',
};

export function isShareableCv(apprenti: Apprenti): boolean {
  return apprenti.statutCv === 'valid';
}

export function isCorrectionStatut(statut: StatutCv): boolean {
  return statut === 'correction-pending' || statut === 'correction-sent';
}

export function isInProgressStatut(statut: StatutCv): boolean {
  return statut === 'in-progress';
}
